module.exports = __webpack_public_path__ + "static/media/desktop.2ad2419.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Magazine/desktop.mp4
// module id = 8pHE
// module chunks = 1